import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M2.397 15.096c.038-.344.057-.517.11-.678q.068-.214.194-.404c.093-.141.215-.264.46-.509L14.167 2.5A2.357 2.357 0 1 1 17.5 5.833L6.495 16.84c-.245.245-.368.367-.51.46a1.7 1.7 0 0 1-.403.195c-.162.052-.334.071-.678.11l-2.82.313.313-2.82Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }